import type { TSelector } from "../../../i18n/types";

export const GOAL_DEFINITIONS = {
  CONSIDERATION: "Drive potential customers to your store or website",
  AWARENESS: "Expose your brand or product to more potential customers",
  CONVERSIONS: "Drive purchases, leads, app installs, and other customer conversions",
};

export const KPI_DEFINITIONS = {
  CLICK_THROUGH_RATE: "The number of click-throughs relative to the number of impressions",
  COST_PER_CLICK: "The average cost for each click on an ad",
  COST_PER_VIDEO_COMPLETION: "The average cost to acquire a video complete conversion",
  VIDEO_COMPETION_RATE: "The number of video completions relative to the number of video starts",
  COST_PER_DETAIL_PAGE_VIEW: "The average cost to acquire a detail page view for a promoted product on Amazon",
  DETAIL_PAGE_VIEW_RATE:
    "The number of detail page views for a promoted product on Amazon relative to the number of ad impressions",
};

// Pattern B: `label` is a lazy selector. Consumers call `t(spec.label)` at
// render time so the user sees a translated string.
export const GOAL_KPI_LOOKUP: Record<
  string,
  {
    label: TSelector;
    accessor: string;
    format: "percent" | "number" | "currency";
    lower?: boolean;
  }
> = {
  DETAIL_PAGE_VIEW_RATE: {
    label: ($) => $.dsp["Detail Page View Rate"],
    accessor: "total_detail_page_view_rate",
    format: "percent",
  },
  TOTAL_RETURN_ON_AD_SPEND: {
    label: ($) => $.dsp["TROAS"],
    accessor: "troas",
    format: "number",
  },
  CLICK_THROUGH_RATE: {
    label: ($) => $.dsp["Click Through Rate"],
    accessor: "click_thru_rate",
    format: "percent",
  },
  RETURN_ON_AD_SPEND: {
    label: ($) => $.dsp["ROAS"],
    accessor: "roas",
    format: "number",
  },
  REACH: {
    label: ($) => $.dsp["Reach"],
    accessor: "unique_reach",
    format: "number",
  },
  COST_PER_DETAIL_PAGE_VIEW: {
    label: ($) => $.dsp["CPDPV"],
    accessor: "cost_per_detail_page_view",
    format: "currency",
    lower: true,
  },
} as const;
